<template>
  <plypp></plypp>
</template>

<script>
import Plypp from './components/Plypp';

export default {
  components: {
    Plypp
  }
};
</script>

<style>
body {
  margin: 0;
  user-select: none;
  font-family: 'Roboto Slab', serif;
  font-weight: 300;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// App.vue?8ea83158